import { useRef, useEffect } from 'react';

export default function AutoExpandingTextInput({ value, onChange, onBlur, onKeyDown, autoFocus, className }) {
  const textareaRef = useRef(null);

  const adjustHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  useEffect(() => {
    adjustHeight();
  }, [value]);

  // Custom onKeyDown to allow Shift+Enter for newline, Enter for submit
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.shiftKey) {
      // Insert a newline at the cursor position
      e.preventDefault();
      const textarea = textareaRef.current;
      if (textarea) {
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const newValue = value.slice(0, start) + '\n' + value.slice(end);
        if (onChange) {
          // Create a synthetic event to match the onChange signature
          onChange({ target: { value: newValue } });
        }
        // Move cursor after the newline
        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
        }, 0);
      }
    } else if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent newline and trigger submit
      if (onKeyDown) onKeyDown(e);
    } else {
      // Allow all other keys to behave normally
      if (onKeyDown) onKeyDown(e);
    }
  };

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      placeholder="Add notes..."
      rows={1}
      autoFocus={autoFocus}
      className={className}
      style={{ width: '100%', resize: 'none', overflow: 'hidden', minHeight: '2.5rem', transition: 'all 0.2s' }}
    />
  );
}